/**
 * Срок и название: две вещи, которые фаза 2 не меняет по существу и потому
 * держит вместе (5.3 docs/homework-phase2-design.md).
 *
 * С 25.09.2026 (просьба владельца) это ОДНА карточка с двумя подзаголовками, а
 * не две: на десктопе она стоит в боковой колонке формы шириной
 * `--w-form-side`, и две карточки подряд ради одного поля в каждой тратили бы
 * высоту колонки, над которой висит главное, то есть предпросмотр и кнопка.
 * Дата и время стоят в одном ряду и на этой ширине помещаются оба; «Без срока»
 * при нехватке места уходит на следующую строку сам (`.acts` переносится).
 *
 * ⚠️ Часовой пояс требуется ТОЛЬКО при постановке срока (4.1 проекта): домашка
 * без срока часовых поясов не касается, и требовать подтверждения зоны там
 * значило бы запереть самый быстрый путь ради поля, которого нет.
 *
 * Предзаполнение срока делает форма ручкой ближайшего занятия, а не раскрытием
 * правила серий на клиенте: очевидный путь дал бы отменённое занятие.
 */
export function DueAndTitle(props: {
  date: string;
  time: string;
  title: string;
  timeZone: string | null;
  /**
   * Чем работа назовётся, если название не вписать. У заготовки это её
   * название, у генераторов темы через запятую. ⚠️ Подпись у ДВУХ источников
   * разная, и подставлять сюда «из названия заготовки» при выбранных темах
   * значит обещать не то имя, которое ученик увидит в списке.
   */
  titleHint: string;
  onDate: (value: string) => void;
  onTime: (value: string) => void;
  onTitle: (value: string) => void;
}) {
  const wantsDue = props.date !== "";
  return (
    <section className="card assign__due">
      <h2>Срок</h2>
      <p className="acts">
        <input
          className="fld fld--auto"
          type="date"
          aria-label="Дата срока"
          value={props.date}
          onChange={(e) => props.onDate(e.target.value)}
        />
        <input
          className="fld fld--auto"
          type="time"
          aria-label="Время срока"
          value={props.time}
          onChange={(e) => props.onTime(e.target.value)}
        />
        {wantsDue && (
          /* Снятие уже введённого срока, то есть отказ, а не выбор: тише полей */
          <button type="button" className="btn btn--quiet" onClick={() => props.onDate("")}>
            Без срока
          </button>
        )}
      </p>
      {wantsDue && props.timeZone === null && (
        <p className="hint hint--err">
          Чтобы поставить срок, подтвердите часовой пояс на экране расписания. Домашку без
          срока можно задать сразу.
        </p>
      )}

      <h2>Название</h2>
      <input
        className="fld"
        type="text"
        aria-label="Название домашки"
        value={props.title}
        placeholder={props.titleHint}
        onChange={(e) => props.onTitle(e.target.value)}
      />
    </section>
  );
}
